import React, { createContext, useContext, useState } from "react";

const IDEContext = createContext();

export const useIDEContext = () => useContext(IDEContext);

export const IDEProvider = ({ children }) => {
  const [filesList, setFilesList] = useState([]);
  const [selectedRepoName, setSelectedRepoName] = useState("");
  const [quickMode, setQuickMode] = useState(false);

  return (
    <IDEContext.Provider
      value={{
        filesList,
        setFilesList,
        selectedRepoName,
        setSelectedRepoName,
        quickMode,
        setQuickMode,
      }}
    >
      {children}
    </IDEContext.Provider>
  );
};
